<template>
<b-card text-variant="white" bg-variant="dark" no-body :style="cardStyle">
  <div
    v-for="item in legendItems"
    :key="item[1]"
    class="ml-2"
  >
    <b-row no-gutters>
      <b-col>
        <div :style="legendStyleFor(item)"></div>
      </b-col>
      <b-col cols="8">
        <span class="ml-2">{{item[1]}}</span>
      </b-col>
    </b-row>
  </div>
</b-card>
</template>

<script>
  import { BCard, BRow, BCol } from 'bootstrap-vue';
  import { each, some, max } from 'lodash';

  export default {
    components: { BCard, BRow, BCol },

    props: ['mapStyle'],

    computed: {
      cardStyle() {
        const width = 145;
        const charMaxLen = max(this.legendItems.map(item => item[1].length));
        const extension = charMaxLen - 'narrow'.length
        if (extension > 0) {
          return {
            width: `${width + (extension * 7)}px`
          }
        } else {
          return {
            width: `${width}px`
          }
        }
      },

      lineStyle() {
        return this.mapStyle.map.layers.route.line;
      },

      legendItems() {
        return this.legendWidthes.concat(this.legendSurfaces);
      },

      legendWidthes() {
        if (this.lineStyle.design == this.lineStyle.track_attribute_deviations.narrow.design) {
          return [];
        }

        return [
          [this.lineStyle.design, 'wide'],
          [this.lineStyle.track_attribute_deviations.narrow.design, 'narrow']
        ];
      },

      legendSurfaces() {
        const surfaces ={};
        each(this.lineStyle.surface_attribute_deviations, (value, key) => {
          if (surfaces[value.color]) {
            surfaces[value.color] = surfaces[value.color].concat(`/${key}`);
          } else {
            surfaces[value.color] = key;
          }
        });

        return Object.keys(surfaces).map(key => ([key, surfaces[key]]));
      }
    },

    methods: {
      legendStyleFor(item) {
        const pathWords = ['normal', 'dashed', 'dotted'];
        if (some(pathWords, word => word == item[0])) {
          const result = {
            'margin': '13px 0',
            'height': '2px',
            'width': '45px'
          }
          const color = 'white'//this.lineStyle.color;
          switch(item[0]) {
            case 'normal':
              result.background = `repeating-linear-gradient(90deg,${color} 0 5px,${color} 0 7px) center`
              break;
            case 'dashed':
              result.background = `repeating-linear-gradient(90deg,${color} 0 10px,#0000 0 12px) center`;
              break;
            case 'dotted':
              result.background = `repeating-linear-gradient(90deg,${color} 0 3px,#0000 0 7px) center`
          }
          return result;
        } else {
          return {
            'background-color': item[0],
            'padding': '5px',
            'border': '3px solid white',
            'width': '45px'
          }
        }
      }
    }
  }
</script>
